export default class NavigationController {
	static NAV_OPEN = false;
	static SCROLL_REFERENCE = null;

	constructor() {
		this.html = document.querySelector("html");
		this.body = document.querySelector("body");
		this.toggles = Array.from(document.querySelectorAll(".js-nav-toggle"));
		this.nav = Array.from(document.querySelectorAll(".js-nav"))[0];
		this.list = Array.from(document.querySelectorAll(".js-nav-list"))[0];
		this.items = Array.from(document.querySelectorAll(".js-nav-item"));

		this.onToggleClicked = ::this.onToggleClicked;
		this.onItemClicked = ::this.onItemClicked;
		this.onScrollOrTouchmove = ::this.onScrollOrTouchmove;
		this.scrollBackToTop = ::this.scrollBackToTop;
		this.onResize = ::this.onResize;
		this.initEvents();
	}

	initEvents() {
		window.addEventListener("resize", this.onResize);
		window.addEventListener("mousewheel", this.onScrollOrTouchmove);
		window.addEventListener("DOMMouseScroll", this.onScrollOrTouchmove);
		window.addEventListener("touchmove", this.onScrollOrTouchmove);
		this.toggles.forEach(toggle => {
			toggle.addEventListener("click", this.onToggleClicked);
		});
		this.items.forEach(item => {
			item.addEventListener("click", this.onItemClicked);
		});
	}

	scrollBackToTop(e) {
		this.list.scrollTo(0, 0);
	}

	onResize(e) {
		if (window.innerWidth >= 992 && NavigationController.NAV_OPEN === true)
			this.onToggleClicked(e, 0);
	}

	onScrollOrTouchmove(e) {
		if (!NavigationController.NAV_OPEN) return;
		window.scroll(0, NavigationController.SCROLL_REFERENCE);
	}

	onItemClicked(e) {
		this.onToggleClicked(e, 750);
	}

	onToggleClicked(e, delay = 0) {
		if (this.nav.classList.contains("is-active")) {
			setTimeout(() => {
				this.nav.classList.remove("is-active");
				NavigationController.SCROLL_REFERENCE = null;
				NavigationController.NAV_OPEN = false;
			}, delay);
			setTimeout(this.scrollBackToTop, delay + 250);
		} else {
			this.nav.classList.add("is-active");
			NavigationController.SCROLL_REFERENCE = window.scrollY;
			NavigationController.NAV_OPEN = true;
		}
	}
}



// WEBPACK FOOTER //
// ./Components/NavigationController.js